(function(){
	"use strict";

	angular
		.module('pwc.filters')
		.filter('sliceFilter', sliceFilter);

	function sliceFilter(){

		return function (input, start) {
			if (! angular.isDefined(start)){
				return input;
			}
			start = +start;
			return angular.isDefined(input) ? input.slice(start) : 0;
		};

	}

})();
